import { isMobile } from 'mobile-device-detect';
// import BackgroundGeolocation from "cordova-background-geolocation";

// let BackgroundGeolocation = window.BackgroundGeolocation
const fieldTracking = {};

fieldTracking.self = {};

fieldTracking.start = function (self) {
  this.self = self;
  console.log('Setting self', fieldTracking.self, this.self);
  return new Promise(((resolve, reject) => {
    // Detect if running on a mobile device
    if (!isMobile) {
      reject();
    }

    console.log('Checking if plugin enabled');

    fieldTracking.init().then(() => {
      console.log('After init');
      fieldTracking.startTrack()
        .then(resolve)
        .catch(reject);
    }).catch(reject);

    /* fieldTracking.enabled().then(function(){
             console.log("Starting tracking")
             BackgroundGeolocation.resetOdometer()
             BackgroundGeolocation.start()
             console.log("Track started")
             resolve()
        }).catch(function(){

            console.log("Plugin is not loaded")

            fieldTracking.init().then(async function(){

                console.log("Plugin loaded.Now starting")
                await BackgroundGeolocation.resetOdometer()
                await BackgroundGeolocation.start()

                console.log("Track started")
                resolve()
            }).catch(function(e){
                console.log(e)
                console.log("Init failed")
                reject()
            })
        }) */
  }));
};

fieldTracking.enabled = function () {
  console.log('Checking plugin state');
  return new Promise(((resolve, reject) => {
    BackgroundGeolocation.getState((e) => {
      console.log('plugin state', e.enabled);
      if (e.enabled) resolve();
      else reject();
    });
  }));
};


fieldTracking.startTrack = async function () {
  console.log('Inside start Tracking');
  return new Promise((async (resolve, reject) => {

      try{
        
        await BackgroundGeolocation.setOdometer(0);
        await BackgroundGeolocation.start();
        resolve()

      }catch(e){
        reject("Failed with permission");
      }
    
    }))
  
};

fieldTracking.stop = async function (self) {
  this.self = self;
  return new Promise((async (resolve, reject) => {
    if (!isMobile) {
      reject();
    }
    // Stop the trip
    const { trip } = fieldTracking.self.$store.getters;
    try {
      await fieldTracking.self.$http.post(`${fieldTracking.self.$store.state.endpoint}trips/${trip}/stop`);
    } catch (e) {
      console.log(e);
      reject(e);
    }
    fieldTracking.self.$store.dispatch('setTrip', '');
    BackgroundGeolocation.stop();
    resolve();
  }));
};

fieldTracking.init = async function () {
  return new Promise((async (resolve, reject) => {
    if (!isMobile) {
      reject('not mobile');
    }
    console.log('Inside init');
    // Create a new Trip
    try {
      var trip = await fieldTracking.self.$http.post(`${fieldTracking.self.$store.state.endpoint}trips/start`);
    } catch (e) {
      reject(e);
    }

    console.log('Trip Created ', trip);
    fieldTracking.self.$store.dispatch('setTrip', trip.body.id);

    console.log('Getters are ', fieldTracking.self.$store.getters);
    console.log('Getters set ', fieldTracking.self.$store.getters.trip);

    console.log('I will post to', `${fieldTracking.self.$store.state.realtimeEndpoint}/add`);
    const postURL = `${fieldTracking.self.$store.state.realtimeEndpoint}/add`;
    BackgroundGeolocation.ready({

      notification: {
        title: "Regular.li Field Tracking", 
        text: "Field Tracking is currently tracking your location changes"
      },
      // Geolocation config
      desiredAccuracy: BackgroundGeolocation.DESIRED_ACCURACY_HIGH,
      desiredOdometerAccuracy: 50,
      //distanceFilter: 10,
      reset: true,
      // Activity Recognition config
      activityRecognitionInterval: 0,
      locationUpdateInterval: 5000,
      fastestLocationUpdateInterval: 1000,
      allowIdenticalLocations: true,
      stopTimeout: 5,
      // Application config
      stopOnTerminate: false,
      startOnBoot: true,
      // HTTP / SQLite config
      url: postURL,
      method: 'POST',
      autoSync: true,
      maxDaysToPersist: 3,
      httpRootProperty: '.',
      locationTemplate: `{ "userId" : "${fieldTracking.self.$store.state.userDetails.id}" , "companyId" : "${fieldTracking.self.$store.state.userDetails.companyId}", "trip":"${fieldTracking.self.$store.getters.trip}",  "gps": { "lat" : <%= latitude %>, "lng": <%= longitude %> }, "time" : "<%= timestamp %>", "accuracy" : <%= accuracy %> ,"odo": <%= odometer %>, "meta": { "speed": <%= speed %> , "heading": <%= heading %> , "altitude" : <%= altitude %> , "activity" : "<%= activity.type %>", "battery_level" : <%= battery.level %>, "battery_charging" : <%= battery.is_charging %> }}`,
      // Logging and Debug
     // debug: true, // <-- Debug sounds & notifications.
      logLevel: BackgroundGeolocation.LOG_LEVEL_VERBOSE,
      headers: { // <-- Optional HTTP headers
        authorization: fieldTracking.self.$store.state.user.id,
      },
      logMaxDays: 3, // <-- 3 days of logs
    }, (state) => {
      // This callback is executed when the plugin is ready to use.
      console.log('BackgroundGeolocation ready: ', state);
      resolve();
    }, (err) => {
      console.log(err);
      reject(err);
    });
  }));
};

export default fieldTracking;
